/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:48:39
 * @Description: file content
 */ 
import React, { Component } from 'react';
import OriginInputNumber from 'bee-input-number';
import { getSysFieldid } from '@platform/api';

require('bee-input-number/build/InputNumber.css');
require('./index.less');

export default class InputNumber extends Component {
	render() {
		let { fieldid, ...others } = this.props;
		return (
			<div fieldid={getSysFieldid(fieldid)} className="input-number-wrapper">
				<OriginInputNumber {...others} />
			</div>
		);
		/* return <div className={`u-form-control-wrapper ${this.props.className}`}>
            {required ? (<span className='input-number-required-tag'>*</span>) : ''}

            <InputNumber {...this.props} />
        </div>*/
	}
}
